'use client';

import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.js";
import { rootStyle } from "../../styles/index.js";
import styled from "../../styled-components.js";
var ListItemElement = styled.li.withConfig({
  displayName: "ListItem__ListItemElement",
  componentId: "sc-14osqn3-0"
})(["", ";list-style-type:none;"], rootStyle());

/**
 * @deprecated
 * This component will be archived soon.
 * Use the {@link https://encore-web.spotify.net/?path=/docs/components-typelistitem--listitem-migration-path TypeListItem} component with variant="ballad", condensed, and listStyleReset props instead for list items containing text.
 * For other implementations, use native li element with list-style-type: none;
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-list-listitem--docs) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/ListItem)
 */
export var ListItem = /*#__PURE__*/React.forwardRef(function ListItem(_ref, ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/React.createElement(ListItemElement, Object.assign({}, props, {
    ref: ref,
    "data-encore-id": ENCORE_DATA_IDS.ListItem
  }));
});